// extracted by mini-css-extract-plugin
export default {"container":"not-found_container__V7Ko4","title":"not-found_title__Gv4Fl text_type_digits-large","caption":"not-found_caption__VNI3L text_type_main-default"};